import { Input as AntdInput } from 'antd';
import styled from 'styled-components';
import { porscheInputStyle, porscheLabelStyle } from './Fields/shared';

const Input = styled(AntdInput)`
    ${porscheLabelStyle}

    &.ant-input {
        height: 48px;
        padding: 8px;

        & input {
            font-size: var(--input-font-size, 1rem);
        }
    }

    ${porscheInputStyle}
`;

export default Input;
